import { SET_COOKIE_RESPONSE } from '../constants/actions';

export function setCookieResponse(header) {
  return {
    type: SET_COOKIE_RESPONSE,
    header,
  };
}
